import { jsxs as d, jsx as s } from "react/jsx-runtime";
import x from "clsx";
import { useRef as B, useState as u, useCallback as i, useLayoutEffect as A, useEffect as L } from "react";
import R from "react-dom";
const V = (m) => x(m), e = "dds-toast-notification-v0142";
function H({
  children: m,
  className: C = "",
  visibleDuration: p,
  variant: f = "error",
  ...N
}) {
  const y = {
    [e]: !0,
    [`${e}--${f}`]: !0,
    [C]: C.length > 0
  }, n = B(null), [E, $] = u(!0), [r, a] = u(!1), [T, o] = u([]), [M, h] = u({});
  let _, g;
  const z = {
    success: "Success",
    error: "Error",
    "system-error": "System error"
  }, b = {
    success: /* @__PURE__ */ s(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M5.8,2.97l-2,2.75C3.67,5.91,3.4,5.93,3.23,5.77
l-1-1c-0.14-0.15-0.14-0.39,0-0.54c0.15-0.14,0.39-0.14,0.54,0l0.68,0.69L5.2,2.53c0.12-0.17,0.35-0.21,0.52-0.08
C5.89,2.57,5.93,2.8,5.8,2.97z`
      }
    ),
    error: /* @__PURE__ */ s(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M3.57,2.29c0-0.24,0.19-0.43,0.43-0.43
s0.43,0.19,0.43,0.43V4c0,0.24-0.19,0.43-0.43,0.43S3.57,4.24,3.57,4V2.29z M4,6.29c-0.32,0-0.57-0.26-0.57-0.58
C3.43,5.4,3.68,5.14,4,5.14S4.57,5.4,4.57,5.71C4.57,6.03,4.32,6.29,4,6.29z`
      }
    ),
    "system-error": /* @__PURE__ */ s(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M3.57,2.29c0-0.24,0.19-0.43,0.43-0.43
s0.43,0.19,0.43,0.43V4c0,0.24-0.19,0.43-0.43,0.43S3.57,4.24,3.57,4V2.29z M4,6.29c-0.32,0-0.57-0.26-0.57-0.58
C3.43,5.4,3.68,5.14,4,5.14S4.57,5.4,4.57,5.71C4.57,6.03,4.32,6.29,4,6.29z`
      }
    )
  }, l = i(() => {
    $(!1), o([`${e}--closed`]), a(!1);
  }, [$, a]), w = i(
    (t) => {
      r && t.target === n.current && l();
    },
    [l, n, r]
  ), I = i(() => {
    const t = document.createElement("div");
    return t.id = `${e}--container`, t.role = "alert", t.classList.add(`${e}__container`), document.body.appendChild(t), t;
  }, []), v = i(() => {
    o([`${e}--closing`]), a(!0);
  }, [o, a]), c = i(() => {
    clearTimeout(_), n.current && (_ = setTimeout(() => {
      var S;
      h({});
      const t = (S = n.current) == null ? void 0 : S.getBoundingClientRect();
      h({ height: t == null ? void 0 : t.height });
    }, 50));
  }, [n, h]);
  return A(() => (window.addEventListener("resize", c), () => window.removeEventListener("resize", c)), [c]), L(() => {
    if (r) {
      const t = setTimeout(() => {
        l();
      }, 2e3);
      return () => clearTimeout(t);
    }
    return () => {
    };
  }, [r, l]), L(() => n.current ? (o([`${e}--opening`]), c(), p !== void 0 && (g = setTimeout(v, p)), () => {
    clearTimeout(_), clearTimeout(g);
  }) : () => {
  }, [c, n, o]), R.createPortal(
    E ? /* @__PURE__ */ d(
      "div",
      {
        className: `${V(y)} ${T}`,
        ...N,
        onTransitionEnd: w,
        style: M,
        ref: n,
        children: [
          /* @__PURE__ */ d("div", { className: `${e}__inner`, children: [
            /* @__PURE__ */ s("div", { className: `${e}__glyph-wrap`, children: /* @__PURE__ */ s("svg", { className: `${e}__glyph`, viewBox: "0 0 8 8", children: b[f] }) }),
            /* @__PURE__ */ d("div", { className: `${e}__content`, children: [
              /* @__PURE__ */ d("div", { className: `${e}__header`, children: [
                /* @__PURE__ */ s("span", { className: `${e}__label`, children: z[f] }),
                /* @__PURE__ */ s(
                  "button",
                  {
                    className: `${e}__close-button`,
                    type: "button",
                    name: "Close notification",
                    onClick: v,
                    "aria-label": "Close notification",
                    children: /* @__PURE__ */ s("svg", { className: `${e}__close-glyph`, viewBox: "0 0 8 8", children: /* @__PURE__ */ s("path", { d: "M1.046,0.118c-0.26-0.18-0.619-0.154-0.85,0.077c-0.26,0.26-0.26,0.682,0,0.943L3.057,4L0.195,6.862L0.118,6.954c-0.18,0.26-0.154,0.619,0.077,0.85c0.26,0.26,0.682,0.26,0.943,0L4,4.943l2.862,2.862l0.092,0.077c0.26,0.18,0.619,0.154,0.85-0.077c0.26-0.26,0.26-0.682,0-0.943L4.943,4l2.862-2.862l0.077-0.092c0.18-0.26,0.154-0.619-0.077-0.85c-0.26-0.26-0.682-0.26-0.943,0L4,3.057L1.138,0.195L1.046,0.118z" }) })
                  }
                )
              ] }),
              /* @__PURE__ */ s("span", { className: `${e}__message`, children: m })
            ] })
          ] }),
          /* @__PURE__ */ s("div", { className: `${e}__block-spacer` })
        ]
      }
    ) : null,
    document.getElementById(`${e}--container`) || I()
    // render the notification as a child of the notification container div
  );
}
export {
  H as ToastNotification
};
//# sourceMappingURL=index.js.map
